import type { LucideIcon } from 'lucide-react';
import {
    ArrowRight,
    Award,
    Calendar,
    Check,
    CircleCheck,
    Compass,
    Globe,
    Headset,
    Mail,
    MapPinned,
    Menu,
    Pause,
    Phone,
    Play,
    Receipt,
    ShieldCheck,
    Snowflake,
    User,
    X,
} from 'lucide-react';

/**
 * Self-hosted SVG icon set (`lucide-react`) replacing the CDN-loaded Font
 * Awesome font. Content modules (`src/content/*.ts`) reference icons by this
 * semantic key (`IconName`) rather than importing a component directly, so
 * the content layer stays framework-agnostic/serializable (CMS/JSON-ready).
 * Render an icon via the `<Icon name="..." />` component
 * (`src/components/ui/Icon.tsx`).
 *
 * Add new icons here — pick any component from https://lucide.dev/icons.
 */
export const iconRegistry = {
    'arrow-right': ArrowRight,
    award: Award,
    calendar: Calendar,
    check: Check,
    'check-circle': CircleCheck,
    compass: Compass,
    globe: Globe,
    headset: Headset,
    mail: Mail,
    'map-pinned': MapPinned,
    menu: Menu,
    pause: Pause,
    phone: Phone,
    play: Play,
    receipt: Receipt,
    'shield-check': ShieldCheck,
    snowflake: Snowflake,
    user: User,
    x: X,
} satisfies Record<string, LucideIcon>;

export type IconName = keyof typeof iconRegistry;
